import { useCreateAdminAxiosInstance } from "./useCreateAdminAxiosInstance.ts";

export function useCreateHeyLightAdminAxiosInstance() {
  return useCreateAdminAxiosInstance(
    import.meta.env.VITE_HEYLIGHT_ADAPTER_BASE_URL,
  );
}
